import React from 'react'
import { WhyUs } from '@/commons/service-hub/WhyUs'
import { airconReasons } from 'data/service-hub-content'

// Aircon preset of the shared WhyUs section. It is used on the hub and several
// sub-pages, so the heading lives here once. Reasons: data/service-hub-content.js.
export const AirconWhyUs = () => (
    <WhyUs
        id="aircon-why-us"
        theme="dark"
        title="Why Choose StringsSG for Aircon Servicing"
        subtitle="Transparent pricing, verified technicians, a 30-day warranty and requests accepted 24/7."
        reasons={airconReasons}
    />
)
